import { useMadSDKList, useMadSDKSingular } from "../../../hooks/madSDK";
import { FilterTypes, OrgContractStatus } from "@madhive/mad-sdk";
export const DEFAULT_ACTIVE_STATUS_FILTER = {
    field: "status",
    type: FilterTypes.EQ,
    value: OrgContractStatus.ACTIVE
};
/**
 * Hook that returns a list of all org contracts
 * @param options
 * @returns {ListData<OrgContract>}
 */
export const useOrgContracts = (options) => useMadSDKList("orgContracts", options);
/**
 * Hook that returns a single active org contract for a specific organization
 * @param orgId - Organization ID to fetch contract for
 * @param options
 * @returns {SingularData<OrgContract>}
 */
export const useOrgContract = (orgId, options) => {
    const activeOptions = { ...(options || {}) };
    const filters = activeOptions?.filters || {};
    const activeFilters = {
        ...filters,
        where: [...(filters.where || []), DEFAULT_ACTIVE_STATUS_FILTER]
    };
    activeOptions.filters = activeFilters;
    return useMadSDKSingular("orgContracts", orgId, activeOptions);
};
//# sourceMappingURL=index.js.map